/**
 * Ordina le righe cliniche dalla più recente alla più vecchia usando prima
 * il timestamp applicativo e poi i metadati Convex come tie-breaker stabile.
 *
 * `updated_at` non va usato per determinare la fase corrente: una modifica a
 * note/data di una fase storica non deve farla tornare artificialmente ultima.
 */
export function sortPrescriptionRowsNewestFirst<
  T extends {
    _id: unknown;
    _creationTime?: number;
    created_at: number;
  },
>(rows: readonly T[]): T[] {
  return [...rows].sort((a, b) => {
    const byCreatedAt = b.created_at - a.created_at;
    if (byCreatedAt !== 0) return byCreatedAt;

    const byCreationTime = (b._creationTime ?? 0) - (a._creationTime ?? 0);
    if (byCreationTime !== 0) return byCreationTime;

    return String(b._id).localeCompare(String(a._id));
  });
}

export function getLatestPrescriptionRow<
  T extends {
    _id: unknown;
    _creationTime?: number;
    created_at: number;
  },
>(rows: readonly T[]): T | undefined {
  return sortPrescriptionRowsNewestFirst(rows)[0];
}
